import clsx from 'clsx';
import React from 'react';
import { states } from '@/constants/lifecycle';
import NavBar from '@/containers/navbar/NavBar';
import ApprovedContainer from '@/containers/ApprovedContainer';
import AnnouncementContainer from '@/notifications/announcements/components/AnnouncementContainer';
import Ribbon from '@/containers/ribbon/Ribbon';
import LayoutManager from '@/layout/containers/LayoutManager';
import AppDialogs from '@/app/components/AppDialogs';
import WebSocketConnection from '@/websocket/components/WebSocketConnection';
import LayoutLoader from '@/layout/components/LayoutLoader';
import PageTracker from './PageTracker';
import Selectors from '../hooks/selectors';

const LayoutPage = ({ store }) => {
  const { readStatus, theme } = Selectors.useLayoutPage();
  return (
    <div className={clsx(`aridhia-theme-${theme}`, 'aridhia-theme-root')}>
      {readStatus === states.ERROR && (<LayoutLoader />)}
      {readStatus === states.SUCCESS && (
        <PageTracker>
          <WebSocketConnection />
          <AppDialogs theme={theme} />
          <NavBar />
          <ApprovedContainer>
            <AnnouncementContainer />
          </ApprovedContainer>
          <Ribbon />
          <LayoutLoader>
            <LayoutManager store={store} />
          </LayoutLoader>
        </PageTracker>
      )}
    </div>
  );
};

export default LayoutPage;
